(ns kyber.interceptors.event-spec
  (:require [cljs.spec.alpha :as s]
            [re-frame.core :as re-frame]))

(s/def :event/data any?)
(s/def :analytic/data map?)
(s/def ::event-spec
  (s/nilable
   (s/keys :opt [:analytic/data
                 :event/data])))

(defn- error-message
  [event-name event-body]
  (str "Invalid event body dispatched for event '" event-name "'.\n"
       "The event body must be a map with expected keys or nil when not "
       "passing data. Got...\n\n"
       (pr-str event-body)
       "\n\nValid keys include:\n\n"
       "`:event/data`: Data intended for event handlers.\n"
       "`:analytic/data`: Data picked up by the 'analytic' interceptor."))

(def ^{:doc "Ensures that all application events are dispatched in a known
             format. This allows us easily add capabilities like analytics."}
  event-spec-interceptor
  (re-frame/->interceptor
   :id :event-spec
   :before
   (fn [context]
     (let [{:keys [event]} (:coeffects context)
           [event-name event-body] event]

       (try
         (when-not (s/valid? ::event-spec event-body)
           (js/console.error (error-message event-name event-body)))
         (catch js/Error e
           (js/console.error "FAILED TO PARSE SPECS:")
           (js/console.error e)))

       context))))
